import React from "react"
import Wrapper from "./wrapper"
import "./src/styles/global.scss"
import Actions from "./src/actions"

export const onClientEntry = () => {
  if (typeof window.IntersectionObserver === `undefined`) {
    require(`intersection-observer`)
  }
}

export const wrapRootElement = ({element}) => {
  return (
    <Wrapper>
      {element}
    </Wrapper>
  )
}

export const onRouteUpdate = ({ location, prevLocation }) => {
  setTimeout(Actions.routeUpdated, 0, { old: prevLocation ? prevLocation.pathname : null, new: location.pathname })
}